import React from "react";
import { PainelDisponibilidadeCard } from "./PainelDisponibilidadeCard";

export const PainelDisponibilidadeGrid = ({ situacoes }) => (
  <div className="container-fluid">
    <div className="row painel-disponibilidade-grid">
      {situacoes.map((situacao) => (
        <div className="col-lg-4 col-md-6 col-12" key={situacao.idAplicacaoFornecedora}>
          <PainelDisponibilidadeCard situacao={situacao} />
        </div>
      ))}
    </div>
  </div>
);
